import { motion } from "framer-motion";
import { fadeUp, stagger } from "@/lib/motion";

// Scroll-reveal wrapper. Use `group` for staggered children with <Reveal.Item>.
export default function Reveal({
  children,
  className = "",
  delay = 0,
  amount = 0.35,
  variants = fadeUp,
  as: Tag = "div",
  testId,
}) {
  const MotionTag = motion[Tag] || motion.div;
  return (
    <MotionTag
      className={className}
      data-testid={testId}
      variants={variants}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount }}
      transition={{ delay }}
    >
      {children}
    </MotionTag>
  );
}

export function RevealGroup({
  children,
  className = "",
  delayChildren = 0,
  staggerChildren = 0.12,
  amount = 0.25,
  testId,
}) {
  return (
    <motion.div
      className={className}
      data-testid={testId}
      variants={stagger(delayChildren, staggerChildren)}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount }}
    >
      {children}
    </motion.div>
  );
}

export function RevealItem({ children, className = "", variants = fadeUp, testId }) {
  return (
    <motion.div className={className} data-testid={testId} variants={variants}>
      {children}
    </motion.div>
  );
}
